export const iconFontAwesomeFilesFileImage = (
	<i className="fa-solid fa-file-image"></i>
);
